var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 19,
    viewBox: "0 0 10 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 16.6667L6.66667 9.70833C8.60833 9.025 10 7.175 10 5C10 2.24167 7.75833 0 5 0C2.24167 0 0 2.24167 0 5C0 7.175 1.39167 9.025 3.33333 9.70833V10L1.66667 11.6667L3.33333 13.3333L1.66667 15L5.03333 18.3333L6.66667 16.6667ZM2.5 5C2.5 3.625 3.625 2.5 5 2.5C6.375 2.5 7.5 3.625 7.5 5C7.5 6.375 6.375 7.5 5 7.5C3.625 7.5 2.5 6.375 2.5 5Z",
    fill: "#FCC900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyIcon);
export default __webpack_public_path__ + "static/media/key-icon.b6a6bc2d03da81be2dcb3fbe037f4d86.svg";
export { ForwardRef as ReactComponent };